<template>
    <div class="module">
        <header class="module__header">
            <a
                class="back-btn"
                @click="goBack('super-products')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Create Product</h1>
        </header>

        <section class="module__body">
            <form @submit.prevent="createProduct">
                <div class="form-group">
                    <label for="name">Name</label>
                    <input
                        id="name"
                        v-model="name"
                        type="text"
                        data-test-id="product-name"
                        required
                        minlength="3"
                        maxlength="64"
                    />
                </div>

                <div class="form-group">
                    <label for="name">User Agent</label>
                    <input
                        id="user-agent"
                        v-model="user_agent"
                        type="text"
                        data-test-id="product-user-agent"
                        required
                        minlength="3"
                        maxlength="64"
                        pattern="^[^\/\s]+$"
                    />
                    <div class="help">
                        No spaces or slashes. Used as product name in
                        <a
                            href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent"
                            target="_new"
                            >user agent</a
                        >
                        string. Examples:
                        <ul class="user-agent-examples">
                            <li>- Firefox<span>/124.0</span></li>
                            <li>- goTennaATAK<span>/1.2.22</span></li>
                            <li v-if="user_agent">- {{ user_agent }}<span>/1.0.0</span></li>
                        </ul>
                    </div>
                </div>

                <div class="form-group">
                    <label for="description">Description</label>
                    <textarea
                        id="description"
                        v-model="description"
                        data-test-id="product-description"
                        minlength="5"
                        maxlength="191"
                        required
                    />
                </div>

                <div class="form-group">
                    <label for="version">API Restricted?</label>
                    <slider-toggle-field
                        name="is_api_restricted"
                        label=""
                        data-test-id="product-is-api-restricted"
                        :value="is_api_restricted"
                        @update="is_api_restricted = $event"
                    ></slider-toggle-field>
                </div>

                <div class="form-group">
                    <label for="version">Disabled?</label>
                    <slider-toggle-field
                        name="is_disabled"
                        label=""
                        data-test-id="product-is-disabled"
                        :value="is_disabled"
                        @update="is_disabled = $event"
                    ></slider-toggle-field>
                </div>

                <form-errors :response="errorResponse" />

                <div class="form-group">
                    <button
                        type="submit"
                        class="btn btn-primary"
                        data-test-id="product-submit"
                        :class="{ active: submitted }"
                    >
                        <div>Create</div>
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'
import hasBackButton from '@/mixins/hasBackButton'
import SliderToggleField from '@/components/SliderToggleField.vue'

export default {
    components: {
        FormErrors,
        SliderToggleField,
    },

    mixins: [canToast, hasBackButton],

    data() {
        return {
            name: null,
            user_agent: null,
            description: null,
            is_disabled: false,
            is_api_restricted: false,
            submitted: false,
            errorResponse: null,
        }
    },

    methods: {
        createProduct() {
            this.$http
                .post(`products`, {
                    name: this.name,
                    user_agent: this.user_agent,
                    description: this.description,
                    is_disabled: Number(this.is_disabled),
                    is_api_restricted: Number(this.is_api_restricted),
                })
                .then(() => {
                    this.toast('Product successfully created')
                    this.$router.push(`/products`)
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
<style scoped lang="scss">
.user-agent-examples li {
    span {
        opacity: 0.5;
    }
}
</style>
